import request from '@/api/request'




//PC工作台-招聘-报名记录
export function messageList(data) {
    return request({
        url: '/web/recruit/enroll/messageList',
        method: 'GET',
        params: data

    })
}




//操作报名职位
export function operateEnroll(data) {
    return request({
        url: '/api/purview/job/operateEnroll',
        method: 'POST',
         data
    })
}





//报名列表
export function getEnroll(data) {
    return request({
        url: '/api/purview/job/getEnroll',//1报名审核，2地址审核，3签写合同，4结算评价
        method: 'GET',
        params: data
    })
}

//http://www.jianzhibei.local/api/purview/interview/postInterview
//发送面试邀请
export function postInterview(data) {
    return request({
        url: '/api/purview/interview/postInterview',
        method: 'POST',
         data
    })
}




//查询地址审核信息
export function getAffirm(data) {
    return request({
        url: '/api/purview/affirm/getAffirm',//1报名审核，2地址审核，3签写合同，4结算评价
        method: 'GET',
        params: data
    })
}


//确认地址
export function postAffirm(data) {
    return request({
        url: '/api/purview/job/affirm/postAffirm',
        method: 'POST',
         data
    })
}


///
////http://www.jianzhibei.local/api/purview/contract/getContract?is_all=false&list_rows=10&page=1&status=1&is_paging=false
//获取合同信息
export function getContract(data) {
    return request({
        url: '/api/purview/contract/getContract',//1报名审核，2地址审核，3签写合同，4结算评价
        method: 'GET',
        params: data
    })
}

export function sendContract(data) {
    return request({
        url: '/api/director/sendContract',
        method: 'POST',
         data
    })
}




//PC工作台-招聘-发送合同
export function contractUpdate(data) {
    return request({
        url: '/web/recruit/enroll/contractUpdate',
        method: 'POST',
        data
    })
}
//http://www.jianzhibei.local/api/contract/signContract
export function signContract(data) {
    return request({
        url: '/api/contract/signContract',
        method: 'POST',
        data
    })
}


//PC工作台-招聘-查看合同
///
export function contractInfo(data) {
    return request({
        url: '/web/recruit/enroll/contractInfo',
        method: 'GET',
        params: data
    })
}





//PC工作台-招聘-结算详情
export function salaryInfo(data) {
    return request({
        url: '/web/recruit/enroll/salary/info',
        method: 'GET',
        params: data
    })
}



//PC工作台-招聘-结算
export function sendSalary(data) {
    return request({
        url: '/web/recruit/enroll/send/salary',
        method: 'POST',
        data
    })
}


//PC工作台-招聘-评价
export function sendAssess(data) {
    return request({
        url: '/web/recruit/enroll/send/assess',
        method: 'POST',
        data
    })
}


